//引入剪切板插件clipboard;
import Clipboard from 'clipboard'; 
import Vue from 'vue'
const vueObject = new Vue({});
export default function(){
    var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        vueObject.$message({
          message: "复制成功",
          type: "success", duration: 1000 
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        vueObject.$message({
          message: "该浏览器不支持自动复制",
          type: "warning", duration: 1000 
        });
        // 释放内存
        clipboard.destroy();
      });
}